import React from 'react'
import styles from './form-wrapper.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const FormWrapper = ({ classes, children, pending }) => (
  <div
    className={classNames(classes.container, { [classes.pending]: pending })}>
    {children}
  </div>
)

export default injectSheet(styles)(FormWrapper)
